export const ToastDuration = 5000;
export const ActivityPageSize = 10;
export const IndexNamespace = 'features.activity_feed.index';
export const FILTERS_KEY = ['filters'];
export var FiltererOptions;
(function (FiltererOptions) {
    FiltererOptions["System"] = "system";
    // Documentation = 'documentation',
    FiltererOptions["Notes"] = "note";
    // Photos = 'photos',
    FiltererOptions["StatusChanges"] = "status_changes";
})(FiltererOptions || (FiltererOptions = {}));
export var SorterOptions;
(function (SorterOptions) {
    SorterOptions["OldestToNewest"] = "oldest_to_newest";
    SorterOptions["NewestToOldest"] = "newest_to_oldest";
})(SorterOptions || (SorterOptions = {}));
export var EntityType;
(function (EntityType) {
    EntityType["Inspection"] = "inspection";
    EntityType["WorkOrder"] = "work_order";
    EntityType["Building"] = "building";
    EntityType["Deficiency"] = "deficiency";
})(EntityType || (EntityType = {}));
export const defaultFiltersState = {
    sort: SorterOptions.OldestToNewest,
    filters: Object.values(FiltererOptions)
};
